import { useCookieConsent } from "react-cookie-manager"

const YouTubeEmbed = (props) => {

    const { videoId, title } = props
    const { detailedConsent, showConsentBanner } = useCookieConsent()
    const hasSocialConsent = detailedConsent?.Social?.consented

    if (!hasSocialConsent)
        return (
            <div className="yt-embed-placeholder">
                <i className="bi bi-youtube yt-embed-icon"></i>
                <p>Este vídeo de YouTube requiere aceptar las cookies de "Social" para poder reproducirse.</p>
                <button type="button" className="main-cta-button" onClick={showConsentBanner}>Gestionar cookies</button>
            </div>
        )

    return (
        <iframe
            title={title}
            src={`https://www.youtube.com/embed/${videoId}`}
            width="100%"
            height="500"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
        ></iframe>
    )

}

export default YouTubeEmbed
